import { createSlice } from "@reduxjs/toolkit";  
import { advertProps } from "../../interfaces/interfaces.d";

const initialState: Array <advertProps> = [
    { id: 'Referral', value: 'Referral'},
    { id: 'facebook', value: 'facebook' },
    { id: 'twitter', value: 'twitter' },
    { id: 'instagram', value: 'instagram' },
    { id: 'LinkedIn', value: 'LinkedIn' },
    { id: 'others', value: 'others' },
];

const advertSlice = createSlice({
    name: 'advert',
    initialState,
    reducers: {}
})

export const selectAllAdverts = (state: any) => state.advert;

export default advertSlice.reducer